import { QueryParamsEnum } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function flightsSortUpdatedRoute(sortCriterion) {
    const paramManager = new QueryParamManager(router.currentRoute() || '/', router.currentParams()); // to make this function pure, these values should be pass in as args
    paramManager.remove(QueryParamsEnum.FSORT);
    if (sortCriterion) {
        paramManager.add(QueryParamsEnum.FSORT, sortCriterion);
    }
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function flightsSortUpdatedRouting(sortCriterion, replaceRoute) {
    if (replaceRoute)
        router.replace(sortCriterion, flightsSortUpdatedRoute);
    else
        router.push(sortCriterion, flightsSortUpdatedRoute);
}
